export const saasCustomerMenu = () => {
  return [
    { label: 'Create New Order', icon: '', url: '/v3/create-order' },
    { label: 'My Orders', icon: 'home', url: '/v3/my-orders' },
    {
      label: 'Manage Account',
      icon: '',
      items: [
        { label: 'Manage Users', icon: '', url: '/v3/user-management' },
        { label: 'Manage Drivers', icon: '', url: '/v3/my-drivers' },
        { label: 'Organisation', icon: '', url: '/v3/organisation-profile' },
        {
          label: 'Driver Checklist',
          icon: '',
          routerLink: ['/app/customers/driverchecklistcustomer'],
        },
      ],
    },
    {
      label: 'Help',
      icon: '',
      url: 'https://www.engineius.co.uk/customer-guides-new',
      target: '_blank',
    },
  ];
};
